"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryBwcOrderPage = queryBwcOrderPage;
var _request = _interopRequireDefault(require("@/utils/request"));
/** 分页查询霸王餐订单 */
function queryBwcOrderPage(params) {
  return (0, _request.default)({
    url: '/portal/system/bwc/order',
    method: 'get',
    params: params
  });
}